export default "__VITE_ASSET__DuMUOD7x__"